var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCall1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.667 34.083q-.75 0-1.271-.521-.521-.52-.521-1.312v-4.833q0-.709.417-1.209.416-.5 1.083-.625l4.208-.916q.584-.125 1.105.062.52.188.937.604l3.75 3.875q3.708-2.041 6.563-4.875 2.854-2.833 5.104-6.625l-3.875-3.791q-.375-.334-.5-.854-.125-.521-.042-1.105l1-4.625q.125-.666.604-1.083.479-.417 1.104-.417h5q.75 0 1.271.521.521.521.521 1.271 0 4.75-2.354 9.458-2.354 4.709-6.125 8.479-3.771 3.771-8.5 6.146t-9.479 2.375Zm22.416-18.291q.959-2.167 1.438-4.063t.521-3.562q0-.125-.063-.188-.062-.062-.187-.062h-3.917q-.125 0-.208.062-.084.063-.125.188l-.834 4.083q0 .083.021.188.021.104.063.187ZM15.417 30.208l-3.209-3.333q-.083-.083-.146-.104-.062-.021-.145.021l-3.709.75q-.125 0-.187.083-.063.083-.063.208v3.917q0 .083.063.146.062.062.146.062 1.666-.041 3.625-.5 1.958-.458 3.625-1.25Zm14.666-14.416ZM15.417 30.208Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCall1);
export default __webpack_public_path__ + "static/media/icon-call1.48758e7ea731de216235da06c030e1cb.svg";
export { ForwardRef as ReactComponent };